// matchesRepository.js
// API repository for matches-related backend calls
import authService from './authService.js';
import { buildApiUrl } from './apiUtils.js';

export const MatchesRepository = {
    async updateMatch(matchId, team1Result, team2Result) {
        const response = await authService.authenticatedRequest(buildApiUrl(`/matches/${matchId}`), {
            method: 'PATCH',
            body: JSON.stringify({ team1Result, team2Result })
        });
        
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to update match: ${response.status} ${response.statusText} - ${errorText}`);
        }
        
        const responseText = await response.text();
        if (!responseText) {
            return { success: true }; // Empty response is OK
        }
        
        try {
            return JSON.parse(responseText);
        } catch (e) {
            // If response is not JSON, return success with the text
            return { success: true, message: responseText };
        }
    }
};

export default MatchesRepository;
